export const Progress = {
  variants: {
    mapProgress: {
      filledTrack: {
        bg: "map.progress-blue",
      },
    },
  },
};
